import { Box, Colors, IcPlus, Text } from 'basic-ui-lib';
import { IBottomNavConfig } from 'layouts/interfaces/AppLayout';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';

interface NavItemProps {
  tab: IBottomNavConfig;
  onOpenSelectStore?: () => void;
}

const BottomNavUserNavItem = ({ tab, onOpenSelectStore }: NavItemProps) => {
  const handleLinkToPage = (tab: IBottomNavConfig) => {
    const token = storage.token.get();
    if (!token) {
      return '/login';
    }

    return tab.link;
  };

  const handleCreateScreen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    onOpenSelectStore?.();
  };

  return (
    <Container to={handleLinkToPage(tab)}>
      {({ isActive }) =>
        tab.isAddScreen ? (
          <div className={`${isActive ? 'active' : ''} content-container is-add-screen`} onClick={handleCreateScreen}>
            <Box
              width={36}
              height={36}
              display='flex'
              justifyContent='center'
              alignItems='center'
              backgroundColor={Colors.secondary[5]}
              borderRadius={100}
            >
              <IcPlus fill={Colors.neutral.bg[1]} width={28} height={28} />
            </Box>
            <Text caption_4 color={isActive ? 'secondary.5' : 'neutral.text.3'}>
              {!tab.isLabelHide && tab.label}
            </Text>
          </div>
        ) : (
          <div className={`${isActive ? 'active' : ''} content-container`}>
            <Box height={'100%'}>{!isActive ? tab.icon : tab.iconActive}</Box>
            <Text caption_4 color={isActive ? 'secondary.5' : 'neutral.text.3'}>
              {!tab.isLabelHide && tab.label}
            </Text>
          </div>
        )
      }
    </Container>
  );
};

export default BottomNavUserNavItem;

const Container = styled(NavLink)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${Colors.neutral.text[5]};
  text-decoration: none;
  gap: 8px;
  text-align: center;
  font-family: 'Be Vietnam Pro';
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  transition: all 0.2s ease;

  .content-container {
    padding-top: 10px;
    border-top: 2px solid transparent;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;

    &.active {
      border-top: 2px solid ${Colors.secondary[5]};
      color: ${Colors.secondary[5]};
    }
  }

  .is-add-screen {
    gap: 4px;
    padding-top: 2px;
  }
`;
